export default __webpack_public_path__ + "6a085886d224495d51b9319885617d5f.png";